import DesktopTransactionApproval from "./desktop/DesktopTransactionApproval";
import MobileTransactionApproval from "./mobile/MobileTransactionApproval";
import MediaQuery from "react-responsive";
import React from "react";

export default function ApprovalContainer() {
    return (
        <MediaQuery maxWidth="599px">
            {(isMobile) => {
                return isMobile ? <MobileTransactionApproval /> : <DesktopTransactionApproval />;
            }}
        </MediaQuery>
    );
}
